import * as React from "react";

import { CollapseMode, FieldSchema, IInputFieldProps, OtherFieldSchema } from "@generation/core";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { ReadContainerUiDefaultsProps } from "../Index";
import { RenderFieldSchemaComponent, RenderFields } from "./RenderFields";
import { Header } from "@shared/common";
import "./SectionContainer.scss";
import { useCollapseContext } from "../Context/Collapse/CollapseContext";

interface ISectionContainerProps extends IInputFieldProps<FieldSchema> {
  uiDefaults?: ReadContainerUiDefaultsProps;
  renderAddedSchemaFields?: (name: string, field: OtherFieldSchema) => RenderFieldSchemaComponent;
}

const toonMeerTekst = "Toon meer";
const toonMinderTekst = "Toon minder";

export const SectionContainer = withHideOnFieldHoc((props: ISectionContainerProps) => {
  const collapseContext = useCollapseContext();
  const [buttonTekst, setButtonTekst] = React.useState(toonMeerTekst);
  const themeClass = props.field.ui?.theme ?? "dark";

  const fieldsetContainerClass =
    props.field.type !== "array"
      ? `fieldset-container fieldset-container--${themeClass} fieldset-container__read-items`
      : `fieldset-container fieldset-container--${themeClass}`;
  const headerText = props.field.label ?? "";
  const flexDirection = props.field.ui?.readOverview?.flexDirection ?? props.field.ui?.flexDirection ?? "row";

  const collapseGroupId = props.field.ui?.readOverview?.collapse?.groupId;
  function toggleCollapse() {
    if (!collapseGroupId) {
      return;
    }
    const isShowing = collapseContext.state.has(collapseGroupId);
    if (isShowing) {
      setButtonTekst(toonMeerTekst);
      collapseContext.dispatch({ type: "COLLAPSE_HIDE", groupId: collapseGroupId });
    } else {
      setButtonTekst(toonMinderTekst);
      collapseContext.dispatch({ type: "COLLAPSE_SHOW", groupId: collapseGroupId });
    }
  }

  const isShowing = collapseGroupId && collapseContext.state.has(collapseGroupId);
  if (props.field.ui?.readOverview?.collapse?.mode === CollapseMode.Target && !isShowing) {
    return null;
  }

  return (
    <div data-testid={props.name} className={`formsection-container formsection-container__${flexDirection}`}>
      {!props.uiDefaults?.hideHeaderText && (
        <Header classes={props.uiDefaults?.headerCssClassName} headerType="h2" headerText={headerText} />
      )}
      {props.field.ui?.readOverview?.collapse?.mode === CollapseMode.Toggle && collapseGroupId && (
        <button
          className="formsection-container__btn-collapsible"
          type="button"
          data-testid={`toon-meer-${collapseGroupId}`}
          onClick={toggleCollapse}
        >
          {buttonTekst}
        </button>
      )}
      {props.field.subLabel && (
        <label className="formsection-container--subLabel">{props.field.subLabel}</label>
      )}
      <div className={fieldsetContainerClass}>
        <RenderFields
          name={props.name}
          field={props.field}
          renderAddedSchemaFields={props.renderAddedSchemaFields}
        />
      </div>
    </div>
  );
});
